import React, {Suspense, useEffect} from 'react'
import templateServices from '../../services/TemplateServices'
import {shallowEqual, useSelector, useDispatch} from 'react-redux';

import {Mode} from '../../common/Foundation';
import BackToTopComponent from '../CompactView/BackToTopComponent';
import {EVENT} from "../../events/listEvents";
import {AlertSlice} from "../../slices/AlertSlice";
import {translate} from 'react-i18next';
import { getSportPeriodDesc } from '../../slices/SportsSlice';

const BodyComponent = (props) => {

  const dispatch = useDispatch();
  let container = 'bodyContainer';
  let position = 'topContainer';
  const templateData = useSelector(state => state.LayoutTemplateSlice.templateData);
  const fixed = useSelector(state => state.LayoutTemplateSlice.fixed);
  const currentViewContainer = useSelector(state => state.LayoutTemplateSlice.currentViewContainer);
  const currentPageContainer = useSelector(state => state.LayoutTemplateSlice.currentPageContainer);
  const isSmallLayout = useSelector(state => state.LayoutTemplateSlice.isSmallLayout, shallowEqual);
  const mode = useSelector(state => state.SportsSlice.options.mode);
  const isAuth = useSelector(state => state.AccountsSlice.user.auth);
  const isNGC = useSelector(state => state.AccountsSlice.isNGC);
  let dataComps = templateServices.listDataCompsByContainerPosition(templateData, currentViewContainer, currentPageContainer, container, position);
  let compsList = templateServices.listComponentsByDataNoGrid(dataComps) || (<div></div>)
  
  useEffect(() => {
    if(currentPageContainer === 'sportPageContainer' || currentPageContainer === 'accountPageContainer') {
      dispatch(getSportPeriodDesc());
    }
  }, [props.lng, currentPageContainer])

  useEffect(() => {
    const successfullySubmitted = JSON.parse(localStorage.getItem("isSuccessfullySubmitted"));
    successfullySubmitted && localStorage.setItem("isSuccessfullySubmitted", false);
    window.listenEvent(EVENT.CLOSE_ALERT_REGISTRATION_SUCCESSFUL, closeAlertRegistrationSuccessful);
    window.addEventListener('storage', displayAlertRegistrationSuccessful)
    return () => {
      // cleanup
      window.stopListenEvent(EVENT.CLOSE_ALERT_REGISTRATION_SUCCESSFUL, closeAlertRegistrationSuccessful);
      window.removeEventListener('storage', displayAlertRegistrationSuccessful)
    }
  }, []);

  const closeAlertRegistrationSuccessful = () => {
    localStorage.setItem("isSuccessfullySubmitted", false);
  }

  const displayAlertRegistrationSuccessful = () => {
    const isSuccessfullySubmitted = JSON.parse(localStorage.getItem("isSuccessfullySubmitted"));
    isSuccessfullySubmitted && dispatch(AlertSlice.actions.alert({
      title: props.t("Registration Successful"),
      i18Message: props.t("You have successfully registered for this promotion."),
      okButton: {text: "OK, GOT IT", action: EVENT.CLOSE_ALERT_REGISTRATION_SUCCESSFUL},
      className: "registration-successful-modal"
    }))
  }

  function getHasNoneHeader() {
    let isHeader = templateData.isNonNeader || false
    if(!isHeader) {
      return ''
    }
    return 'none-header'
  }


  // function renderBackToTopIcon() {
  //   let clazzName = "backtoTop" + (props.fixedWhenScroll === true && fixed.header === "fixed" ? " display" : "");

  //   return  (
  //     <div className={clazzName} id="backtoTop" title="Back to Top">
  //     </div>
  //   )
   
  // }
  function isFixLeftMenu (){
    const modesNotSupport = [Mode.VS_NORMAL, Mode.VS_PARLAY, Mode.VS_PARLAY, Mode.LC, Mode.TV];
    return currentPageContainer === 'sportPageContainer' && modesNotSupport.indexOf(mode) < 0
  }
  
  const isCasinoPageContainer = () => currentPageContainer === 'casinoPageContainer' || currentPageContainer === 'liveCasinoPageContainer';
  const isDisplayBackToTop =  props.fixedWhenScroll === true && (fixed.header === "fixed" || fixed.header === "fixed-iframe" || fixed.header === "fixed-no-auth");

  const renderBackToTop = () => {
    if (window.env.isB2B) {
      return (
        <BackToTopComponent isDisplay={isDisplayBackToTop}></BackToTopComponent>
      );
    } else {
      return (
        !isSmallLayout ? <BackToTopComponent isDisplay={isDisplayBackToTop}></BackToTopComponent> : null
      );
    }
  }

  return (
      <div id="body"
           className={`${getHasNoneHeader()} ${isFixLeftMenu() ? 'fixLeftMenu' : ''} ${currentPageContainer !== 'accountPageContainer' && currentPageContainer !== 'promotionContainer' && !isCasinoPageContainer() ? fixed.body : ''} ${isCasinoPageContainer() ? 'casino-page-body' : ''} ${currentPageContainer} ${isAuth ? 'auth' : ''} ${isNGC ? 'ngc' : ''}`} >
        <Suspense fallback={null}>
          <div className="topContainer">
            {compsList}
          </div>
          <div className="main-container" id={`${isCasinoPageContainer() ? 'casino' : ''}`}>
            {props.bodyLeftMenu}
            {props.bodyCenter}
            {props.bodyRightMenu}
          </div>
          {renderBackToTop()}

        </Suspense>
    </div>
  );

}

export default translate()((React.memo(BodyComponent)));


// WEBPACK FOOTER //
// ./src/app/components/BodyComponent/index.js